import { useMutation } from "@tanstack/react-query";
import { photoSeriesDelete } from "common/api/citajteo/photo_series/photo_series";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";

type UsePhotoSeriesDeleteParams = {
  invalidateKeys?: string[];
  successHandle?: Function;
  errorHandle?: Function;
};

export const usePhotoSeriesDelete = (
  hookParams?: UsePhotoSeriesDeleteParams
) => {
  const { invalidateQueriesByKeys } = useInvalidateQueryByKeys();
  const { mutate: photoSeriesDeleteMutate } = useMutation({
    mutationFn: async (id: string) => {
      const response = await photoSeriesDelete(id);

      if (!response) {
        throw new Error("photoSeriesDelete failed");
      }

      return response;
    },
    onSuccess: (response) => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
      }

      if (hookParams?.successHandle) {
        hookParams.successHandle(response);
      }
    },
    onError: (error) => {
      if (hookParams?.errorHandle) {
        hookParams.errorHandle(error);
      }
    },
  });

  return { photoSeriesDeleteMutate };
};
